import React from "react";

const TableSkelton = ({ colspan,rowSpan=10 }) => {
  const rows = Array.from({ length: rowSpan }); // 10 rows

  return (
    <tbody>
      {rows.map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: colspan }).map((_, colIndex) => (
            <td key={colIndex} className="border border-gray-100 p-2">
              <div className="h-[18px] bg-gray-200 rounded animate-pulse"></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default TableSkelton;
